(function($) {
	
	$(document).ready(function() {
		
		$('form.js-dropdown-filter select.js-switch').change(function() {
			// get selected filter parameters
			var val = $(this).val();
			// check if value is set, othervise load root url
			if (val.length == 0) {
				val = $('form.js-dropdown-filter').data('base-url');
			}
			// redirect
			window.location = val;
		});
		
		$('form.js-dropdown-filter select.js-submit').change(function() {
			// submit the form
			$(this).closest("form").submit();
		});

		$('input.js-suggest').each( function( i, input ) {
			var $input = $(input);
			$input.attr('type', 'search');
			$input.autocompleter({
				source: $input.data('source'),
				cache: false,
				delay: 250,
				minLength: 3,
				combine: function(params) {
					return {
						q: params.query
					};
				},
				callback: function(value, index, object) {
					if ($input.hasClass('js-switch')) {
						window.location = value;
					} else if ($input.hasClass('js-submit')) {
						$input.closest("form").submit();
					}
			    }
			});
		});
		
	});
	
}(jQuery));